<div class="row mt-3 mb-3">
    <div class="col-md-3 align-section">
        <mat-label class="font-style">Torque Pattern</mat-label>
    </div>
</div>
<div class="row">
    <!-- <div class="col-md-12"> -->
    <div>
        <img style="max-height: 350px; max-width: 100%" [src]="diagramItem?.pathLowRes" />
    </div>
</div>
